<template>
  <div class="c-community-search-container">
    <div class="grid-container">
      <div class="c-community-search-heading">
        <h2 v-if="searchResultsText" class="c-community-search-heading__title">
          {{ searchResultsText }}
        </h2>
        <button
          v-if="options.expandFilters"
          v-bind:class="[
            showFilters
              ? 'c-expand-filters c-expand-filters--open'
              : 'c-expand-filters',
          ]"
          v-on:click="expandFilters"
          >{{ options.expandFilters.text }}
      </button>
      </div>
    </div>

    <div class="c-community-search" v-show="showFilters">
      <div class="c-community-search__inner grid-container">
        <div class="c-community-search__filters">
          <div class="c-community-search__column">
            <drop-down
              v-if="options.sortByOptions"
              v-bind:filters="options.sortByOptions"
              event-name="updateSortBy"
            />
            <drop-down
              v-if="options.typeOptions"
              v-bind:filters="options.typeOptions"
              event-name="updateType"
            />
          </div>
          <div class="c-community-search__column">
            <checkbox v-bind:filters="options.filters" />
          </div>
        </div>
        <div class="c-community-search__btn-wrapper">
          <a
            href="#"
            class="c-button c-button--brand"
            v-on:click="filterEventHandler"
            >{{ options.buttonText }}</a
          >
        </div>
      </div>
    </div>

    <div class="grid-container">
      <div
        class="c-community-search__results"
        v-if="options.displayType === 'activity'"
      >
        <activity-results-card
          v-for="result in results"
          v-bind:key="result.id"
          v-bind:result="result"
        />
      </div>
      <div
        class="c-community-search__results c-community-search__results--three-column"
        v-if="options.displayType === 'project'"
      >
        <project-results-card
          v-for="result in results"
          v-bind:key="result.id"
          v-bind:result="result"
        />
      </div>
      <div
        class="c-community-search__results c-community-search__results--three-column"
        v-if="options.displayType === 'project 2'"
      >
        <project-results-card-two
          v-for="result in results"
          v-bind:key="result.id"
          v-bind:result="result"
        />
      </div>
      <div
        class="c-community-search__no-results"
        v-if="options.noResults && results.length === 0"
      >
        <p>{{ noResultsText }}</p>
      </div>
      <search-paging
        searchType="documents"
        v-bind:currentPage="pageNumber"
        v-bind:totalPages="totalPages"
        v-on:movePage="loadResultsPage"
        v-if="results.length > 0 && paginationStyle === 'page-list'"
      >
      </search-paging>
      <div
        class="c-community-search__btn-container"
        v-if="
          paginationStyle !== 'page-list' &&
          options.loadMoreText &&
          pageNumber < totalPages
        "
      >
        <button
          class="c-button c-button--brand"
          v-on:click="loadMoreResultsHandler"
        >
          {{ options.loadMoreText }}
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import "url-search-params-polyfill";
import axios from "axios";
import endpoints from "Globals/mando.endpoints";
import Checkbox from "./checkbox.vue";
import DropDown from "./dropdown.vue";
import ActivityResultsCard from "./activityResultsCard.vue";
import ProjectResultsCard from "./projectResultsCard.vue";
import ProjectResultsCardTwo from "./projectResultsCardTwo.vue";
import SearchPaging from "./SearchPaging.vue";
import "url-search-params-polyfill";

export default {
  name: "community-search-results",
  components: {
    Checkbox,
    DropDown,
    ActivityResultsCard,
    ProjectResultsCard,
    ProjectResultsCardTwo,
    SearchPaging,
  },
  data() {
    return {
      searchTerm: "",
      location: "",
      tags: "",
      sortBy: "",
      type: "",
      showFilters: "",
      results: [],
      pageNumber: null,
      totalPages: null,
      totalResults: null,
      searchResultsText: null,
      noResultsText: null,
      pagingActive: false,
    };
  },
  props: {
    options: {
      type: Object,
      required: true,
    },
    searchConfig: {
      type: String,
      required: true,
    },
    componentId: {
      type: String,
      required: true,
    },
    siteId: {
      type: String,
      required: true,
    },
    paging: {
      type: String,
      required: true,
    },
  },
  created() {
    this.$eventBus.$on("updateFilters", this.updateFilterValues);
    this.$eventBus.$on("updateSortBy", this.updateSortByValues);
    this.$eventBus.$on("updateType", this.updateTypeValues);
    this.$eventBus.$on("updateSearchTerm", this.UpdateSearchTermValue);
    this.$eventBus.$on("updateLocation", this.UpdateLocationValue);
    this.$eventBus.$on("onSearchClick", this.searchBoxEventHandler);
  },
  mounted() {
    const initialQueryString = this.buildQueryString();
    const searchEndpoint = this.paging
      ? "getCommunitySearchResultsPaged"
      : "getCommunitySearchResults";

      axios({
        method: "get",
        url: `${endpoints(searchEndpoint)}${initialQueryString}`,
      })
      .then((response) => {
        this.results = response.data.results;
        this.pageNumber = response.data.pageNumber;
        this.totalPages = response.data.totalPages;
        this.totalResults = response.data.totalResults;
        this.paginationStyle = response.data.paginationStyle;
        this.setSearchResultsText(response.data.totalResults);
      })
      .catch((error) => console.warn(error));
  },
  methods: {
    getQuery(key, searchTerm) {
      const query =
        searchTerm &&
        searchTerm.split("&").filter((item) => item.indexOf(key) > -1);

      return query.length && query[0].split("=")[1];
    },
    buildQueryString() {
      const searchTerm = window.location.search;
      let params = {
        searchConfig: this.searchConfig,
        componentId: this.componentId,
        siteId: this.siteId,
      };
      if (this.searchTerm || this.getQuery("searchTerm", searchTerm)) {
        params = Object.assign(params, {
          searchTerm:
            this.searchTerm || this.getQuery("searchTerm", searchTerm),
        });
      }
      if (this.location || this.getQuery("region", searchTerm)) {
        params = Object.assign(params, {
          region:
            this.location === "any"
              ? ""
              : this.location || this.getQuery("region", searchTerm),
        });
      }
      if (this.type) {
        params = Object.assign(params, { type: this.type });
      }
      if (this.sortBy) {
        params = Object.assign(params, { sortBy: this.sortBy });
      }
      if (this.tags) {
        params = Object.assign(params, { tags: this.tags });
      }
      const queryString = Object.keys(params)
        .map((key) => `${key}=${params[key]}`)
        .join("&");

      return Object.keys(params).length ? encodeURI(`?${queryString}`) : "";
    },
    searchResults(pageNumber) {
      const self = this;
      const queryString = this.buildQueryString();
      const pageResults = `&page=${pageNumber}`;
      const searchEndpoint = this.paging
        ? "getCommunitySearchResultsPaged"
        : "getCommunitySearchResults";

      axios({
        method: "get",
        url: `${endpoints(searchEndpoint)}${queryString}${pageResults}`,
      })
        .then((response) => {
          if (
            response.data.paginationStyle === "page-list" ||
            !self.pagingActive
          ) {
            self.results = response.data.results;
          } else {
            self.results = self.loadMoreResults(response.data.results);
            self.pagingActive = false;
          }
          self.pageNumber = pageNumber ? pageNumber : 1;
          self.totalPages = response.data.totalPages;
          self.totalResults = response.data.totalResults;
          self.paginationStyle = response.data.paginationStyle;
          self.setSearchResultsText(response.data.totalResults);
          return self.$eventBus.$emit("updatedSearchResults", queryString);
        })
        .catch((error) => console.warn(error));
    },
    loadMoreResults(newResults) {
      return [...new Set([...this.results, ...newResults])];
    },
    searchBoxEventHandler() {
      this.searchResults();
    },
    setSearchResultsText(resultCount) {
      const convertedSearchResultsText = this.options.searchResultsText.replace(
        "{total}",
        resultCount
      );
      this.searchResultsText = convertedSearchResultsText;
    },
    setNoResultsText(searchTerm) {
      const noResultsText = this.options.noResults.replace(
        "{searchTerm}",
        searchTerm
      );
      this.noResultsText = noResultsText;
    },
    filterEventHandler(e) {
      this.pagingActive = false;
      e.preventDefault();
      this.searchResults();
    },
    UpdateSearchTermValue(item) {
      this.searchTerm = item;
      this.setNoResultsText(item);
    },
    UpdateLocationValue(item) {
      this.location = item;
    },
    updateFilterValues(item) {
      this.tags = item.join(",");
    },
    updateSortByValues(item) {
      this.sortBy = item;
    },
    updateTypeValues(item) {
      this.type = item;
    },
    expandFilters(e) {
      e.preventDefault();
      let expandFilterState = (this.options.expandFilters.isOpen = !this.options
        .expandFilters.isOpen); // toggles boolean state
      this.showFilters = expandFilterState;
    },
    loadResultsPage(pageNumber) {
      this.pagingActive = true;
      this.searchResults(pageNumber);
    },
    loadMoreResultsHandler(e) {
      e.preventDefault();
      this.pageNumber = this.pageNumber + 1;
      this.pagingActive = true;
      this.searchResults(this.pageNumber);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/components/pelican/community-search-results/communitySearchResults.vue